<template>
  <div>
    {{ doctors }}
  </div>
</template>

<script setup>
import { computed } from "vue"

const props = defineProps({
  object: {
    type: Object
  }
})

const doctors = computed(() => {
  const doctors = props.object?.visits.map(visit => visit.doctor?.full_name || '')
  return [...new Set(doctors)].filter(name => name).join(', ')
})
</script>
